import {
    getAdminSetting,
    setDateFormat
} from '../constants/model-reducers/admin-setting.settings';
import { httpGet, httpPost } from '../utils/api.utils';

const defaultState = () => ({
    adminSettingId: 0,
    activeDateFormat: {},
    dateFormatOptions: []
});

const initialState = defaultState();

export const adminSettingActions = {
    getAdminSetting: () => async (dispatch) => {
        var result = await httpGet('common/adminsetting');
        sessionStorage.setItem('AdminSetting', JSON.stringify(result));

        dispatch({
            type: getAdminSetting,
            data: result
        });
    },
    saveDateFormat: (dateFormatId) => async (dispatch, state) => {
        try {
            const { adminSettingId } = state().adminSetting;
            var payload = {
                AdminSettingID: adminSettingId,
                DateFormatID: dateFormatId
            };
            var result = await httpPost('common/adminsetting/updateDateFormat/', payload);
            dispatch({
                type: setDateFormat,
                data: result
            });
        }
        catch (ex) {
            return false;
        }
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getAdminSetting:
            return {
                ...state,
                adminSettingId: action.data.AdminSettingID,
                activeDateFormat: action.data.ActiveDateFormat,
                dateFormatOptions: action.data.DateFormatOptions
            };
        case setDateFormat:
            return {
                ...state,
                activeDateFormat: action.data,
            };
        default:
            return state;
    }
}